// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__19S0g","containerItemsCenter":"Skeleton_containerItemsCenter__IxO42"};